import { Clock, Mail } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'

interface ProgressSavedScreenProps {
  email: string
  onResume: () => void
}

export function ProgressSavedScreen({ email, onResume }: ProgressSavedScreenProps) {
  return (
    <div className="panel-arrive flex flex-col items-center pt-12 text-center">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-[var(--green-bg)]">
        <Clock
          size={36}
          className="animate-in zoom-in-75 text-[var(--green)] duration-500"
        />
      </div>

      <h1
        className="mb-3 font-display text-[28px] font-light leading-tight text-[var(--ink)]"
      >
        Progress Saved
      </h1>

      <p className="clara-body mb-4 max-w-xs text-[var(--ink-2)]">
        Your uploads are safe. Come back to this link any time before it expires
        to add more or to submit.
      </p>

      {email && (
        <div className="mb-6 flex items-center gap-2 text-[13px] text-[var(--ink-3)]">
          <Mail size={14} />
          <span>
            We've sent a reminder with the link to <strong>{email}</strong>.
          </span>
        </div>
      )}

      {!email && (
        <p className="clara-small mb-6 max-w-xs text-[var(--ink-3)]">
          Use the link in the original email we sent you to return here.
        </p>
      )}

      <div className="mx-auto mb-6 h-px w-16 bg-[var(--gold-border)]" />

      <Button
        type="button"
        variant="link"
        onClick={onResume}
        className="clara-small text-[var(--green)]"
      >
        Back to my uploads
      </Button>
    </div>
  )
}
